import { CmsComponentsBase } from '@/cmsComponents/base';
import CourseCategoryTeasers from '@/components/CourseCategoryTeasers/CourseCategoryTeasers';
import Container from '@uikit/components/Container/Container';
import Section from '@uikit/components/Section/Section';

// eslint-disable-next-line
export default {
  ...CmsComponentsBase,
  'courses-section': Section,
  'courses-container': Container,
  'course-category-teasers': CourseCategoryTeasers,
};
